import React, { useEffect, useRef, useState } from 'react'
import { PhoneIcon } from '@heroicons/react/24/outline'

interface ICallPhone {
  callTo: string
}

function RingCentralModal({ callTo }: ICallPhone) {
  const iframeRef = useRef(null)
  const [ready, setReady] = useState(false)

  const eventMessages = (e) => {
    switch (e?.data.type) {
      case 'rc-dialer-status-notify':
        // get dialer status from widget
        if (e.data.ready) setReady(true)
        break
      default:
        break
    }
  }

  useEffect(() => {
    window.addEventListener('message', eventMessages)

    return () => window.removeEventListener('message', eventMessages)
  }, [])

  useEffect(() => {
    if (ready) {
      // call to number
      iframeRef.current?.contentWindow?.postMessage(
        {
          type: 'rc-adapter-new-call',
          phoneNumber: callTo,
          toCall: true,
        },
        '*'
      )
    }
  }, [ready])

  return (
    <div
      id='overlay'
      className='top-0 left-0 fixed w-screen h-screen bg-slate-700/60 z-50 flex items-center justify-center'
    >
      <iframe
        ref={iframeRef}
        id='ringcentralIframe'
        width='300'
        height='500'
        allow='microphone'
        src='https://apps.ringcentral.com/integration/ringcentral-embeddable/1.8.4/app.html?clientId=VKj_umzRSouuF3E03FtOJg&appServer=https://platform.ringcentral.com'
        style={{ position: 'absolute', zIndex: '999' }}
      />
    </div>
  )
}

function CallPhone({ callTo }: ICallPhone) {
  const [showModal, setShowModal] = useState(false)

  return (
    <a
      className='relative'
      href='#'
      onClick={(e) => {
        e.stopPropagation()
        setShowModal((prevState) => !prevState)
      }}
    >
      <PhoneIcon className='w-4 h-4' />
      {showModal && <RingCentralModal callTo={callTo} />}
    </a>
  )
}

export default CallPhone
